<template>
    <el-collapse v-model="indicesCollapseAreaPreservacaoPermanente">
        <el-collapse-item :name="`collapse-area-preservacao-permanente`">
            <template #title>
                <span class="titulo">
                    {{
                        $tc(
                            'certification.messages.permanent_preservation_area'
                        )
                    }}
                </span>
            </template>
            <div class="collapse-item-bloco-info">
                <div class="info">
                    <label
                        >{{
                            $tc(
                                'certification.messages.permanent_preservation_areas'
                            )
                        }}:</label
                    >
                    <span>{{
                        formatNumber(dados?.areaPreservacaoPermanente, 2)
                    }}</span>
                </div>
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.permanent_preservation_area_in_consolidated_area'
                            )
                        }}
                        :
                    </label>
                    <span>{{
                        formatNumber(
                            dados?.areaPreservacaoPermanenteEmAreaConsolidada,
                            2
                        )
                    }}</span>
                </div>
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.permanent_preservation_area_in_remaining_native_vegetation'
                            )
                        }}:
                    </label>
                    <span>{{
                        formatNumber(
                            dados?.areaPreservacaoPermanenteEmAreaVegetacaoNativa,
                            2
                        )
                    }}</span>
                </div>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import formatter from '@/utils/formatters';

export default {
    name: 'CollapseAreaPreservacaoPermanente',
    props: {
        dados: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseAreaPreservacaoPermanente: []
        };
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        }
    }
};
</script>

<style lang="scss" scoped>
.titulo {
    font-weight: bold;
}
</style>
